import React, { useState } from 'react';
import { FaBriefcase, FaPaperPlane, FaCheckCircle, FaTimesCircle, FaPlus, FaTrash } from 'react-icons/fa';
import { API_BASE } from '../config';
import './ContactPage.css';
import './JobApplicationPage.css';

const EduRow = ({ label, fieldName, data, onChange }) => (
  <div className="job-edu-row">
    <span className="job-edu-label">{label}</span>
    <input placeholder="Okul Adı" value={data.school} onChange={e => onChange(fieldName, 'school', e.target.value)} />
    <input placeholder="Bölümü" value={data.department} onChange={e => onChange(fieldName, 'department', e.target.value)} />
    <input placeholder="Başlangıç" type="month" value={data.startDate} onChange={e => onChange(fieldName, 'startDate', e.target.value)} />
    <input placeholder="Bitiş" type="month" value={data.endDate} onChange={e => onChange(fieldName, 'endDate', e.target.value)} />
    <input placeholder="Derece" value={data.grade} onChange={e => onChange(fieldName, 'grade', e.target.value)} />
  </div>
);

const emptyExperience = { company: '', position: '', startDate: '', endDate: '', leaveReason: '', salary: '' };
const emptyCourse = { topic: '', institution: '', duration: '', date: '' };
const emptyReference = { name: '', company: '', position: '', phone: '' };
const emptyLanguage = { language: '', readLevel: '', writeLevel: '', speakLevel: '' };

const JobApplicationPage = () => {
  const [modal, setModal] = useState({ open: false, type: '', message: '' });
  const [sending, setSending] = useState(false);
  const [photo, setPhoto] = useState(null);
  const [photoPreview, setPhotoPreview] = useState(null);

  const [form, setForm] = useState({
    applicationDate: new Date().toISOString().split('T')[0],
    appliedPosition: '',
    // A. Kişisel
    firstName: '', lastName: '', birthPlace: '', birthDate: '',
    gender: '', nationality: 'TC', nationalityOther: '',
    address: '', phoneHome: '', phoneMobile1: '', phoneMobile2: '', email: '',
    militaryStatus: '', militaryDate: '', militaryExemptReason: '',
    driverLicense: [],
    maritalStatus: '', spouseJob: '',
    smoking: '', childCount: '',
    // B. Eğitim
    eduPrimary: { school: '', department: '', startDate: '', endDate: '', grade: '' },
    eduHighSchool: { school: '', department: '', startDate: '', endDate: '', grade: '' },
    eduAssociate: { school: '', department: '', startDate: '', endDate: '', grade: '' },
    eduBachelor: { school: '', department: '', startDate: '', endDate: '', grade: '' },
    eduMaster: { school: '', department: '', startDate: '', endDate: '', grade: '' },
    eduPhd: { school: '', department: '', startDate: '', endDate: '', grade: '' },
    // C. Yabancı Dil
    languages: [{ ...emptyLanguage }],
    // D. Bilgisayar
    computerExcel: '', computerWord: '', computerPowerPoint: '',
    // E. İş Tecrübesi
    experiences: [{ ...emptyExperience }],
    // F. Kurs/Sertifika
    courses: [{ ...emptyCourse }],
    // G-H
    memberships: '', hobbies: '',
    // I. Diğer
    healthIssue: 'hayir', healthDetail: '',
    criminalRecord: 'hayir', criminalDetail: '',
    emergencyName: '', emergencyRelation: '', emergencyPhone: '',
    // J. Referanslar
    references: [{ ...emptyReference }],
    // K. Ücret
    salaryExpGross: '', salaryExpNet: '',
    // L. Ek
    sizeTop: '', sizeBottom: '', shoeSize: '',
    emergencyContactName: '', emergencyContactPhone: '',
    shiftWork: '',
  });

  const set = (field, value) => setForm(prev => ({ ...prev, [field]: value }));
  const setNested = (parent, field, value) => setForm(prev => ({ ...prev, [parent]: { ...prev[parent], [field]: value } }));

  const setArrayItem = (arrName, index, field, value) => {
    setForm(prev => {
      const arr = [...prev[arrName]];
      arr[index] = { ...arr[index], [field]: value };
      return { ...prev, [arrName]: arr };
    });
  };

  const addArrayItem = (arrName, template) => {
    setForm(prev => ({ ...prev, [arrName]: [...prev[arrName], { ...template }] }));
  };

  const removeArrayItem = (arrName, index) => {
    setForm(prev => ({ ...prev, [arrName]: prev[arrName].filter((_, i) => i !== index) }));
  };

  const toggleDriverLicense = (val) => {
    setForm(prev => {
      const arr = prev.driverLicense.includes(val)
        ? prev.driverLicense.filter(v => v !== val)
        : [...prev.driverLicense, val];
      return { ...prev, driverLicense: arr };
    });
  };

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPhoto(file);
      const reader = new FileReader();
      reader.onloadend = () => setPhotoPreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.firstName || !form.lastName || !form.phoneMobile1 || !form.appliedPosition) {
      setModal({ open: true, type: 'error', message: 'Lütfen ad, soyad, telefon ve başvurulan pozisyon alanlarını doldurun.' });
      return;
    }
    setSending(true);
    try {
      let photoUrl = '';
      if (photo) {
        const fd = new FormData();
        fd.append('file', photo);
        const upRes = await fetch(`${API_BASE}/upload-public`, { method: 'POST', body: fd });
        if (upRes.ok) {
          const upData = await upRes.json();
          photoUrl = upData.url || '';
        }
      }
      const payload = { ...form, photo: photoUrl, createdAt: new Date().toISOString() };
      const res = await fetch(`${API_BASE}/job-application`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!res.ok) throw new Error();
      setModal({ open: true, type: 'success', message: 'Başvurunuz başarıyla alındı. En kısa sürede sizinle iletişime geçeceğiz.' });
    } catch {
      setModal({ open: true, type: 'error', message: 'Başvuru gönderilirken hata oluştu. Lütfen tekrar deneyin.' });
    }
    setSending(false);
  };

  const levels = ['', 'Az', 'Orta', 'İyi', 'Çok İyi'];

  return (
    <div className="contact-page">
      {modal.open && (
        <div className="contact-modal-overlay" onClick={() => setModal({ ...modal, open: false })}>
          <div className="contact-modal" onClick={e => e.stopPropagation()}>
            <div className={`contact-modal-icon ${modal.type}`}>
              {modal.type === 'success' ? <FaCheckCircle /> : <FaTimesCircle />}
            </div>
            <h3 className="contact-modal-title">{modal.type === 'success' ? 'Başarılı!' : 'Hata'}</h3>
            <p className="contact-modal-message">{modal.message}</p>
            <button className="contact-modal-btn" onClick={() => setModal({ ...modal, open: false })}>Tamam</button>
          </div>
        </div>
      )}

      <section className="contact-hero">
        <div className="contact-hero-overlay"></div>
        <div className="contact-hero-content">
          <span className="contact-hero-badge"><FaBriefcase style={{ marginRight: 6 }} /> KARİYER</span>
          <h1 className="contact-hero-title">İş Başvurusu</h1>
          <p className="contact-hero-desc">Dihiz A.Ş. ailesine katılmak için aşağıdaki formu eksiksiz doldurun.</p>
        </div>
      </section>

      <section className="contact-main">
        <div className="job-form-container">
          <form onSubmit={handleSubmit}>

            {/* Başvuru Bilgileri */}
            <div className="job-section">
              <div className="job-section-header">
                <span className="job-section-badge">Başvuru</span>
                <h2>Başvuru Bilgileri</h2>
              </div>
              <div className="contact-form-row">
                <div className="contact-field">
                  <label>Başvuru Tarihi</label>
                  <input type="date" value={form.applicationDate} disabled style={{ opacity: 0.7 }} />
                </div>
                <div className="contact-field">
                  <label>Başvurulan Pozisyon *</label>
                  <input value={form.appliedPosition} onChange={e => set('appliedPosition', e.target.value)} placeholder="Garson, Aşçı, Resepsiyonist..." required />
                </div>
              </div>
            </div>

            {/* A. Kişisel Bilgiler */}
            <div className="job-section">
              <div className="job-section-header">
                <span className="job-section-badge">A</span>
                <h2>Kişisel Bilgiler</h2>
              </div>

              <div className="job-photo-row">
                <div className="job-photo-upload">
                  <label className="job-photo-label">
                    {photoPreview ? <img src={photoPreview} alt="Fotoğraf" /> : <span>Fotoğraf<br/>Yükle</span>}
                    <input type="file" accept="image/*" onChange={handlePhotoChange} hidden />
                  </label>
                </div>
                <div style={{ flex: 1 }}>
                  <div className="contact-form-row">
                    <div className="contact-field"><label>Adınız *</label><input value={form.firstName} onChange={e => set('firstName', e.target.value)} required /></div>
                    <div className="contact-field"><label>Soyadınız *</label><input value={form.lastName} onChange={e => set('lastName', e.target.value)} required /></div>
                  </div>
                  <div className="contact-form-row">
                    <div className="contact-field"><label>Doğum Yeriniz</label><input value={form.birthPlace} onChange={e => set('birthPlace', e.target.value)} /></div>
                    <div className="contact-field"><label>Doğum Tarihiniz</label><input type="date" value={form.birthDate} onChange={e => set('birthDate', e.target.value)} /></div>
                  </div>
                </div>
              </div>

              <div className="contact-form-row">
                <div className="contact-field">
                  <label>Cinsiyet</label>
                  <div className="job-radio-group">
                    <label className="job-radio"><input type="radio" name="gender" value="kadin" checked={form.gender === 'kadin'} onChange={e => set('gender', e.target.value)} /> Kadın</label>
                    <label className="job-radio"><input type="radio" name="gender" value="erkek" checked={form.gender === 'erkek'} onChange={e => set('gender', e.target.value)} /> Erkek</label>
                  </div>
                </div>
                <div className="contact-field">
                  <label>Uyruk</label>
                  <div className="job-radio-group">
                    <label className="job-radio"><input type="radio" name="nat" value="TC" checked={form.nationality === 'TC'} onChange={e => set('nationality', e.target.value)} /> TC</label>
                    <label className="job-radio"><input type="radio" name="nat" value="diger" checked={form.nationality === 'diger'} onChange={e => set('nationality', e.target.value)} /> Diğer</label>
                    {form.nationality === 'diger' && <input placeholder="Belirtiniz" value={form.nationalityOther} onChange={e => set('nationalityOther', e.target.value)} style={{ width: 120, marginLeft: 8 }} />}
                  </div>
                </div>
              </div>

              <div className="contact-field"><label>İkametgah Adresi</label><textarea rows={2} value={form.address} onChange={e => set('address', e.target.value)} /></div>

              <div className="contact-form-row" style={{ gridTemplateColumns: '1fr 1fr 1fr' }}>
                <div className="contact-field"><label>Ev Telefonu</label><input type="tel" value={form.phoneHome} onChange={e => set('phoneHome', e.target.value)} /></div>
                <div className="contact-field"><label>Cep Telefonu 1 *</label><input type="tel" value={form.phoneMobile1} onChange={e => set('phoneMobile1', e.target.value)} required /></div>
                <div className="contact-field"><label>Cep Telefonu 2</label><input type="tel" value={form.phoneMobile2} onChange={e => set('phoneMobile2', e.target.value)} /></div>
              </div>

              <div className="contact-field"><label>E-posta</label><input type="email" value={form.email} onChange={e => set('email', e.target.value)} /></div>

              <div className="contact-form-row">
                <div className="contact-field">
                  <label>Askerlik Durumu</label>
                  <select value={form.militaryStatus} onChange={e => set('militaryStatus', e.target.value)}>
                    <option value="">Seçiniz</option>
                    <option value="tamamlandi">Tamamlandı</option>
                    <option value="tecilli">Tecilli</option>
                    <option value="muaf">Muaf</option>
                  </select>
                  {(form.militaryStatus === 'tamamlandi' || form.militaryStatus === 'tecilli') && (
                    <input type="date" placeholder="Tarih" value={form.militaryDate} onChange={e => set('militaryDate', e.target.value)} style={{ marginTop: 8 }} />
                  )}
                  {form.militaryStatus === 'muaf' && (
                    <input placeholder="Muafiyet Nedeni" value={form.militaryExemptReason} onChange={e => set('militaryExemptReason', e.target.value)} style={{ marginTop: 8 }} />
                  )}
                </div>
                <div className="contact-field">
                  <label>Sürücü Belgesi</label>
                  <div className="job-checkbox-group">
                    {['B', 'C', 'D', 'E', 'F', 'Yok'].map(v => (
                      <label key={v} className="job-checkbox"><input type="checkbox" checked={form.driverLicense.includes(v)} onChange={() => toggleDriverLicense(v)} /> {v}</label>
                    ))}
                  </div>
                </div>
              </div>

              <div className="contact-form-row">
                <div className="contact-field">
                  <label>Medeni Durum</label>
                  <div className="job-radio-group">
                    <label className="job-radio"><input type="radio" name="marital" value="evli" checked={form.maritalStatus === 'evli'} onChange={e => set('maritalStatus', e.target.value)} /> Evli</label>
                    <label className="job-radio"><input type="radio" name="marital" value="bekar" checked={form.maritalStatus === 'bekar'} onChange={e => set('maritalStatus', e.target.value)} /> Bekar</label>
                  </div>
                  {form.maritalStatus === 'evli' && <input placeholder="Eşinizin Mesleği" value={form.spouseJob} onChange={e => set('spouseJob', e.target.value)} style={{ marginTop: 8 }} />}
                </div>
                <div className="contact-field">
                  <label>Sigara</label>
                  <div className="job-radio-group">
                    <label className="job-radio"><input type="radio" name="smoking" value="evet" checked={form.smoking === 'evet'} onChange={e => set('smoking', e.target.value)} /> Evet</label>
                    <label className="job-radio"><input type="radio" name="smoking" value="hayir" checked={form.smoking === 'hayir'} onChange={e => set('smoking', e.target.value)} /> Hayır</label>
                  </div>
                  <input placeholder="Çocuk Sayısı" type="number" min="0" value={form.childCount} onChange={e => set('childCount', e.target.value)} style={{ marginTop: 8 }} />
                </div>
              </div>
            </div>

            {/* B. Eğitim */}
            <div className="job-section">
              <div className="job-section-header"><span className="job-section-badge">B</span><h2>Eğitim Bilgileri</h2></div>
              <div className="job-edu-table">
                <div className="job-edu-head">
                  <span></span><span>Okul Adı</span><span>Bölümü</span><span>Başlangıç</span><span>Bitiş</span><span>Derece</span>
                </div>
                <EduRow label="İlköğretim" fieldName="eduPrimary" data={form.eduPrimary} onChange={setNested} />
                <EduRow label="Lise" fieldName="eduHighSchool" data={form.eduHighSchool} onChange={setNested} />
                <EduRow label="Ön Lisans" fieldName="eduAssociate" data={form.eduAssociate} onChange={setNested} />
                <EduRow label="Lisans" fieldName="eduBachelor" data={form.eduBachelor} onChange={setNested} />
                <EduRow label="Y. Lisans" fieldName="eduMaster" data={form.eduMaster} onChange={setNested} />
                <EduRow label="Doktora" fieldName="eduPhd" data={form.eduPhd} onChange={setNested} />
              </div>
            </div>

            {/* C. Yabancı Dil */}
            <div className="job-section">
              <div className="job-section-header"><span className="job-section-badge">C</span><h2>Yabancı Dil Bilgisi</h2></div>
              {form.languages.map((lang, i) => (
                <div key={i} className="job-lang-row">
                  <input placeholder="Dil" value={lang.language} onChange={e => setArrayItem('languages', i, 'language', e.target.value)} />
                  <select value={lang.readLevel} onChange={e => setArrayItem('languages', i, 'readLevel', e.target.value)}><option value="">Okuma</option>{levels.filter(Boolean).map(l => <option key={l} value={l}>{l}</option>)}</select>
                  <select value={lang.writeLevel} onChange={e => setArrayItem('languages', i, 'writeLevel', e.target.value)}><option value="">Yazma</option>{levels.filter(Boolean).map(l => <option key={l} value={l}>{l}</option>)}</select>
                  <select value={lang.speakLevel} onChange={e => setArrayItem('languages', i, 'speakLevel', e.target.value)}><option value="">Konuşma</option>{levels.filter(Boolean).map(l => <option key={l} value={l}>{l}</option>)}</select>
                  {form.languages.length > 1 && <button type="button" className="job-remove-btn" onClick={() => removeArrayItem('languages', i)}><FaTrash /></button>}
                </div>
              ))}
              <button type="button" className="job-add-btn" onClick={() => addArrayItem('languages', emptyLanguage)}><FaPlus /> Dil Ekle</button>
            </div>

            {/* D. Bilgisayar */}
            <div className="job-section">
              <div className="job-section-header"><span className="job-section-badge">D</span><h2>Bilgisayar Bilgisi</h2></div>
              <div className="contact-form-row" style={{ gridTemplateColumns: '1fr 1fr 1fr' }}>
                <div className="contact-field"><label>Excel</label><select value={form.computerExcel} onChange={e => set('computerExcel', e.target.value)}><option value="">Seçiniz</option>{levels.filter(Boolean).map(l => <option key={l} value={l}>{l}</option>)}</select></div>
                <div className="contact-field"><label>Word</label><select value={form.computerWord} onChange={e => set('computerWord', e.target.value)}><option value="">Seçiniz</option>{levels.filter(Boolean).map(l => <option key={l} value={l}>{l}</option>)}</select></div>
                <div className="contact-field"><label>PowerPoint</label><select value={form.computerPowerPoint} onChange={e => set('computerPowerPoint', e.target.value)}><option value="">Seçiniz</option>{levels.filter(Boolean).map(l => <option key={l} value={l}>{l}</option>)}</select></div>
              </div>
            </div>

            {/* E. İş Tecrübesi */}
            <div className="job-section">
              <div className="job-section-header"><span className="job-section-badge">E</span><h2>İş Tecrübesi</h2></div>
              {form.experiences.map((exp, i) => (
                <div key={i} className="job-exp-card">
                  <div className="contact-form-row">
                    <div className="contact-field"><label>Firma/Kurum</label><input value={exp.company} onChange={e => setArrayItem('experiences', i, 'company', e.target.value)} /></div>
                    <div className="contact-field"><label>Görev</label><input value={exp.position} onChange={e => setArrayItem('experiences', i, 'position', e.target.value)} /></div>
                  </div>
                  <div className="contact-form-row" style={{ gridTemplateColumns: '1fr 1fr 1fr 1fr' }}>
                    <div className="contact-field"><label>Giriş</label><input type="month" value={exp.startDate} onChange={e => setArrayItem('experiences', i, 'startDate', e.target.value)} /></div>
                    <div className="contact-field"><label>Çıkış</label><input type="month" value={exp.endDate} onChange={e => setArrayItem('experiences', i, 'endDate', e.target.value)} /></div>
                    <div className="contact-field"><label>Ayrılma Sebebi</label><input value={exp.leaveReason} onChange={e => setArrayItem('experiences', i, 'leaveReason', e.target.value)} /></div>
                    <div className="contact-field"><label>Ücret</label><input value={exp.salary} onChange={e => setArrayItem('experiences', i, 'salary', e.target.value)} /></div>
                  </div>
                  {form.experiences.length > 1 && <button type="button" className="job-remove-btn" onClick={() => removeArrayItem('experiences', i)}><FaTrash /> Kaldır</button>}
                </div>
              ))}
              <button type="button" className="job-add-btn" onClick={() => addArrayItem('experiences', emptyExperience)}><FaPlus /> İş Tecrübesi Ekle</button>
            </div>

            {/* F. Kurs/Sertifika */}
            <div className="job-section">
              <div className="job-section-header"><span className="job-section-badge">F</span><h2>Kurs / Sertifika / Ödüller</h2></div>
              {form.courses.map((c, i) => (
                <div key={i} className="job-lang-row">
                  <input placeholder="Konu" value={c.topic} onChange={e => setArrayItem('courses', i, 'topic', e.target.value)} />
                  <input placeholder="Kurum" value={c.institution} onChange={e => setArrayItem('courses', i, 'institution', e.target.value)} />
                  <input placeholder="Süre" value={c.duration} onChange={e => setArrayItem('courses', i, 'duration', e.target.value)} />
                  <input placeholder="Tarih" value={c.date} onChange={e => setArrayItem('courses', i, 'date', e.target.value)} />
                  {form.courses.length > 1 && <button type="button" className="job-remove-btn" onClick={() => removeArrayItem('courses', i)}><FaTrash /></button>}
                </div>
              ))}
              <button type="button" className="job-add-btn" onClick={() => addArrayItem('courses', emptyCourse)}><FaPlus /> Ekle</button>
            </div>

            {/* G-H */}
            <div className="job-section">
              <div className="job-section-header"><span className="job-section-badge">G-H</span><h2>Üyelikler ve Hobiler</h2></div>
              <div className="contact-field"><label>Üye Olduğunuz Dernek ve Kuruluşlar</label><textarea rows={2} value={form.memberships} onChange={e => set('memberships', e.target.value)} /></div>
              <div className="contact-field"><label>Hobileriniz</label><textarea rows={2} value={form.hobbies} onChange={e => set('hobbies', e.target.value)} /></div>
            </div>

            {/* I. Diğer */}
            <div className="job-section">
              <div className="job-section-header"><span className="job-section-badge">I</span><h2>Diğer Bilgiler</h2></div>
              <div className="contact-form-row">
                <div className="contact-field">
                  <label>Sağlık Probleminiz Var mı?</label>
                  <div className="job-radio-group">
                    <label className="job-radio"><input type="radio" name="health" value="hayir" checked={form.healthIssue === 'hayir'} onChange={e => set('healthIssue', e.target.value)} /> Hayır</label>
                    <label className="job-radio"><input type="radio" name="health" value="evet" checked={form.healthIssue === 'evet'} onChange={e => set('healthIssue', e.target.value)} /> Evet</label>
                  </div>
                  {form.healthIssue === 'evet' && <input placeholder="Açıklayınız" value={form.healthDetail} onChange={e => set('healthDetail', e.target.value)} style={{ marginTop: 8 }} />}
                </div>
                <div className="contact-field">
                  <label>Mahkumiyet Durumu</label>
                  <div className="job-radio-group">
                    <label className="job-radio"><input type="radio" name="criminal" value="hayir" checked={form.criminalRecord === 'hayir'} onChange={e => set('criminalRecord', e.target.value)} /> Hayır</label>
                    <label className="job-radio"><input type="radio" name="criminal" value="evet" checked={form.criminalRecord === 'evet'} onChange={e => set('criminalRecord', e.target.value)} /> Evet</label>
                  </div>
                  {form.criminalRecord === 'evet' && <input placeholder="Açıklayınız" value={form.criminalDetail} onChange={e => set('criminalDetail', e.target.value)} style={{ marginTop: 8 }} />}
                </div>
              </div>
              <div className="contact-form-row" style={{ gridTemplateColumns: '1fr 1fr 1fr' }}>
                <div className="contact-field"><label>Ulaşılacak Kişi</label><input placeholder="Adı Soyadı" value={form.emergencyName} onChange={e => set('emergencyName', e.target.value)} /></div>
                <div className="contact-field"><label>Yakınlığı</label><input value={form.emergencyRelation} onChange={e => set('emergencyRelation', e.target.value)} /></div>
                <div className="contact-field"><label>Telefonu</label><input type="tel" value={form.emergencyPhone} onChange={e => set('emergencyPhone', e.target.value)} /></div>
              </div>
            </div>

            {/* J. Referanslar */}
            <div className="job-section">
              <div className="job-section-header"><span className="job-section-badge">J</span><h2>Referanslar</h2></div>
              {form.references.map((ref, i) => (
                <div key={i} className="job-lang-row">
                  <input placeholder="Adı Soyadı" value={ref.name} onChange={e => setArrayItem('references', i, 'name', e.target.value)} />
                  <input placeholder="Çalıştığı Kurum" value={ref.company} onChange={e => setArrayItem('references', i, 'company', e.target.value)} />
                  <input placeholder="Görevi" value={ref.position} onChange={e => setArrayItem('references', i, 'position', e.target.value)} />
                  <input placeholder="Telefon" value={ref.phone} onChange={e => setArrayItem('references', i, 'phone', e.target.value)} />
                  {form.references.length > 1 && <button type="button" className="job-remove-btn" onClick={() => removeArrayItem('references', i)}><FaTrash /></button>}
                </div>
              ))}
              <button type="button" className="job-add-btn" onClick={() => addArrayItem('references', emptyReference)}><FaPlus /> Referans Ekle</button>
            </div>

            {/* K-L */}
            <div className="job-section">
              <div className="job-section-header"><span className="job-section-badge">K-L</span><h2>Ücret & Ek Bilgiler</h2></div>
              <div className="contact-form-row">
                <div className="contact-field"><label>Ücret Beklentisi (Brüt)</label><input value={form.salaryExpGross} onChange={e => set('salaryExpGross', e.target.value)} placeholder="₺" /></div>
                <div className="contact-field"><label>Ücret Beklentisi (Net)</label><input value={form.salaryExpNet} onChange={e => set('salaryExpNet', e.target.value)} placeholder="₺" /></div>
              </div>
              <div className="contact-form-row" style={{ gridTemplateColumns: '1fr 1fr 1fr' }}>
                <div className="contact-field"><label>Üst Beden</label><input value={form.sizeTop} onChange={e => set('sizeTop', e.target.value)} /></div>
                <div className="contact-field"><label>Alt Beden</label><input value={form.sizeBottom} onChange={e => set('sizeBottom', e.target.value)} /></div>
                <div className="contact-field"><label>Ayakkabı No</label><input value={form.shoeSize} onChange={e => set('shoeSize', e.target.value)} /></div>
              </div>
              <div className="contact-field">
                <label>Vardiyalı Çalışır mısınız?</label>
                <div className="job-radio-group">
                  <label className="job-radio"><input type="radio" name="shift" value="evet" checked={form.shiftWork === 'evet'} onChange={e => set('shiftWork', e.target.value)} /> Evet</label>
                  <label className="job-radio"><input type="radio" name="shift" value="hayir" checked={form.shiftWork === 'hayir'} onChange={e => set('shiftWork', e.target.value)} /> Hayır</label>
                </div>
              </div>
            </div>

            <p className="job-disclaimer">Yukarıda vermiş olduğum bilgilerin eksiksiz ve doğru olduğunu beyan ederim.</p>

            <button type="submit" className="contact-submit-btn job-submit" disabled={sending}>
              {sending ? 'Gönderiliyor...' : <><FaPaperPlane /> Başvuruyu Gönder</>}
            </button>
          </form>
        </div>
      </section>
    </div>
  );
};

export default JobApplicationPage;
